import { ActivityEntityName } from '../shared';

export type ClaimValidationResultsType = 'Allow' | 'Warn' | 'Block';

export interface ClaimValidationResult {
    entity: ActivityEntityName;
    valid: boolean;
    messages?: string[];
    resultType?: ClaimValidationResultsType;
}

export interface ClaimValidationResultGroup {
    valid: boolean;
    entities?: ClaimValidationResult[];
}

export function invalidClaimResult(message: string) {
    return {
        valid: false,
        messages: [message],
        entity: ActivityEntityName.WorkOrder
    };
}

export function invalidClaimResultGroup(message: string) {
    return {
        valid: false,
        entities: [invalidClaimResult(message)]
    };
}